import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';
import * as api from 'dashboard/resources/actual-and-projected-settlements.api';
import template from './actual-and-projected-settlements-widget.html';

const mapStateToThis = ({ config, dictionary, session }) => {
  const { usesProjectedSettlements } = config;
  const { locale, retailer } = session;
  const terms = dictionary.terms[locale];

  return {
    locale,
    retailer,
    usesProjectedSettlements,
    terms,
  };
};

const mapDispatchToThis = {};

// eslint-disable-next-line no-undef
@Inject('$scope', '$ngRedux', '$state', 'gettextCatalog')
class ActualAndProjectedSettlementsWidgetController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.projectedSettlements = this.gettextCatalog.getString('Projected Settlements');
    this.actualSettlements = this.gettextCatalog.getString('Actual Settlements');
    this.widgetTitle = this.usesProjectedSettlements ? this.projectedSettlements : this.actualSettlements;

    this.retailerId = this.$state.params.retailerNo || this.retailer.retailerId;
    this.loadDataAsync(() => api.fetchActualAndProjectedSettlements(this.retailerId));
  }

  $onDestroy() {
    this.unsubscribe();
  }

  onDownloadReport() {
    return api.downloadActualSettlementsReport(this.retailerId, this.locale);
  }
}

export default class ActualAndProjectedSettlementsWidgetComponent {
  constructor() {
    this.template = template;
    this.controller = ActualAndProjectedSettlementsWidgetController;
    this.bindings = {
      isEditMode: '<',
      isRemovable: '<',
      removeWidget: '&?',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/actual-and-projected-settlements/actual-and-projected-settlements-widget-component.js